<template>
    <Modal
    cuerpoModal="overflow"
    @closeModal="handleCerrar"
    :showMovilHeader="true"
    :fit="true"
    :showHeader="false"
    :linea="false"
  >
  <div class="body-container">
<img src="../../assets/imgs/icons/calendario-verde.svg" alt="img" class="img" />
<p class="mensaje">{{`¿Desea agendar una cita a ${cliente.name} ${cliente.first_lastname || ""} ${cliente.second_lastname || ""}? `}}</p>
<div class="btns-container">
    <button @click="$emit('cerrar')" class="btn-cancelar">Cancelar</button>
    <button @click="$emit('aceptar')" class="btn-aceptar">Aceptar</button>

</div>
  </div>
  </Modal>
</template>

<script>
import Modal from '../Modales/Modal.vue';
export default {
components:{
    Modal
},
emits:["cerrar","aceptar"],
props:{
    cliente:{
        type:Object,
        required:true
    }
}
}
</script>

<style scoped>

.body-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 530px;
height: 398px;
}
.img{
width: 86px;
height: 91px;
margin-bottom: 30px;
}
.mensaje{
    margin-bottom: 90px;
    font: normal normal bold 20px/27px Open Sans;
letter-spacing: 0px;
color: #0A4F9C;
}
.btns-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 20px 0 30px 0; */
}
.btn-cancelar {
  width: 172px;
  height: 22px;
  text-align: center;
  font: normal normal bold 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #4caf50;
}
.btn-aceptar {
  width: 172px;
  text-align: center;
  height: 40px;
  background: #4caf50 0% 0% no-repeat padding-box;
  border-radius: 4px;
  color: #fff;
}

@media screen and (max-width: 767px) {

    .body-container{
        height: calc(100vh - 60px);
        width: 100%;
    }

    .mensaje{
    margin-bottom: 90px;
    font: normal normal bold 16px/27px Open Sans;
    text-align: center;
    }
}
</style>